export default __webpack_public_path__ + "img/es-588726968eb69ae20b7e093fc9a87c64.png";